import { render } from "./MenuLeft.vue?vue&type=template&id=35754943&scoped=true"
import script from "./MenuLeft.vue?vue&type=script&lang=ts"
export * from "./MenuLeft.vue?vue&type=script&lang=ts"

import "./MenuLeft.vue?vue&type=style&index=0&id=35754943&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35754943"

export default script